import React, { useState } from 'react'
import {  auth } from '../../firebase/firebaseConfig'
import './AuthModal.module.css'
 import Register from './Register'
import Login from './Login'
import { useTranslation } from 'react-i18next'
import { ReactComponent as CloseIcon } from '../../assets/Close-btn.svg'
import ForgotPassword from '../auth/ForgotPassword'

interface AuthModalProps{
  type: string,
  show:boolean,
  onClose:()=>void;
  setType:(value:string)=>void;
}
const AuthModal:React.FC<AuthModalProps>=({type,show,onClose,setType})=> {
 const {t}=useTranslation()
if(!show)return <></>


  return (
    <div className='bg-[rgba(25,25,25,0.25)] fixed top-0 left-0 w-full h-full flex items-center justify-center' onClick={onClose} style={{zIndex: 99999}}>
        <div className={`bg-white  p-5 rounded-[20px] max-w-[95%] overflow-y-auto max-h-[90%]  ${type=='login'?'w-[632px]':"w-fit"} h-fit relative px-[20px] md:px-[45px] pt-[28px] md:pt-[50px] pb-[28px] md:pb-[35px]`} onClick={(e)=>e.stopPropagation()}>
          <div className='flex items-center justify-between tracking-[1px] mb-[36px] md:mb-[65px]'>
            <div />
            <h1 className='font-semibold leading-none text-center text-[32px] md:text-[45px] '>{t(type==='login'?"navigation.login": type==='register'?"navigation.register": "auth.forgotPassword")}</h1>
            <CloseIcon
              className='cursor-pointer'
              onClick={onClose}
            />
          </div>
          
          {type==='login'&&
            <Login onClose={onClose} setType={setType}/>
          }
          {type==='register'&&
           <Register onClose={onClose} setType={setType}/>
          }
          {
            type==='forgotPassword'&&
            <ForgotPassword/>
          }
        </div>
    </div>
  )
}

export default AuthModal